/* ============
 * Dashboard
 * ============
 *
 * This is the dashboard page.
 */
import organizationSettingsService from './../../services/organizationSettings';
import ediOrderService from './../../services/ediOrder';
import orderService from './../../services/order';
import shippingService from './../../services/shippingProvider';
import { mapGetters, mapMutations } from 'vuex';
import shippingTransformer from './../../transformers/shippingConfirm';
import Forms from './../../utils/forms/forms';
import moment from 'moment';

export default {
  props: {
    warehouseId: {
      Type: Number,
      required: true,
    },
    orderConfirmNotification: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      form: new Forms({
        shippingProviderId: {
          value: '',
          type: 'select',
        },
        shippingDate: {
          value: moment().format('YYYY-MM-DD'),
          type: 'date',
        },
      }),
      shippingProviders: [],
      showReminder: false,
      loading: false,
      displayError: false,
    };
  },

  computed: {
    ...mapGetters({
      currentOrder: 'currentOrder',
      account: 'account',
      settings: 'organizationSettings',
      orderProducts: 'allOrderProducts',
    }),

    unassignedProducts() {
      return this.orderProducts.filter(op => op.quantityConfirmed != op.quantityPacked);
    },
  },

  mounted() {
    this.getResources();
  },

  watch: {
    'form.shippingProviderId': function (newValue) {
      console.log(this.currentOrder.internalNote);
      const provider = this.shippingProviders.find(p => p.id === parseInt(newValue)) || null;
      if (provider.code === 'CCNO_STK') {
        this.showReminder = true;
      } else {
        this.showReminder = false;
      }
    },
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    setShippingProviders(shippingProviders) {
      let hasModule = false;
      if (this.account.modules.length > 0) {
        for (let i = 0; i < this.account.modules.length; i++) {
          if (this.account.modules[i].name == 'Shipping Provider') {
            // this.form.hideField('warehouseId');
            hasModule = true;
          }
        }
      }
      if (hasModule) {
        this.form.setOptions('shippingProviderId', shippingProviders.map(c => ({ id: c.id, name: `${c.name} ` })));
        if (this.form.options.shippingProviderId.length > 0) this.displayError = false;
      } else {
        this.displayError = false;
        this.form.hideField('shippingProviderId');
      }
    },

    /**
     * Fetch the component's required resources.
     */
    getResources() {
      this.loading = true;
      Promise.all([
        shippingService.warehouseShippingProvider(this.warehouseId),
        organizationSettingsService.show(),
      ]).then((data) => {
        this.loading = false;
        if (data[0].length == 0) {
          this.displayError = true;
          this.loading = false;
        } else {
          this.loading = false;
          this.form.shippingProviderId = data[0][0].id;
        }
        this.shippingProviders = data[0];
        this.setShippingProviders(this.shippingProviders);
      });
    },

    store() {
      this.loading = false;
      this.form.loading = true;
      const client = shippingTransformer.send(
        Object.assign({}, this.form.data())
      );

      client.order_confirm_notification = this.orderConfirmNotification;

      return orderService.confirmShipping(this.currentOrder.id, client)
        .then((data) => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: this.$t('static.ediOrders.edit.confirmSuccess'),
            customClass: 'success',
          });
          if (this.currentOrder.orderType === 'EDI') {
            ediOrderService.show(this.currentOrder.ediOrderId);
          }
          this.closeModal();
        }).catch((errors) => {
          this.loading = false;
          this.form.loading = false;
          let message = this.$t('static.ediOrders.edit.confirmError');
          if (errors.data.delivery_date) {
            message = errors.data.delivery_date[0];
          }

          if (errors.data.shipping_date) {
            message = errors.data.shipping_date[0];
          }

          if (errors.data.shipping_provider_id) {
            message = errors.data.shipping_provider_id[0];
          }

          if (errors.data.data.warehouse === 'inactive') {
            message = errors.data.message;
          }

          this.$message({
            showClose: true,
            message,
            customClass: 'error',
          });
        });
    },
    /*
     * Closes the modal
     */
    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
    },
  },
  components: {
    VForm: require('./../../components/form/form.vue'),
    VMessage: require('./../../components/form/message/message.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/orderConfirmShipping/orderConfirmShipping.js